var chunkToChildrenMap = {"9805":["69189","58778"],"78369":["69189"],"23233":["69189","58778"],"96163":["69189"],"36968":["69189","58778"],"20613":["69189","58778"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};